// extracted by mini-css-extract-plugin
export default {"component":"IVmESzlI","clickable":"Fgg8Iwq0","label":"fJ7VXIz_","icon":"dwV8jxp9","label-container":"weMh9rsx","tooltip":"RUUGrfCE","tooltip-label":"_eUrn7pS"};